export const DESKTOP_BREAKPOINT_PX = 1024;
export const MOBILE_REFERENCE_MAX_WIDTH_PX = 450;
